// extracted by mini-css-extract-plugin
export default {"neon":"by4uXZIj","borders":"dATlK14p","content":"BQnkrVcC"};